import React from 'react';
import { useIntl } from 'react-intl';
import CustomBtn from '../../../../../../generic/CustomBtn/CustomBtn';
import { ReactComponent as HomogeneousImage } from '../../../../../../assets/image/carbon/homogeneous.svg';
import { ReactComponent as HeterogeneousImage } from '../../../../../../assets/image/carbon/heterogeneous.svg';
import './TreeDensityPopup.scss';

const TreeDensityPopup = ({ closeHandler }) => {
  const translate = useIntl();
  return (
    <div className="tree-density__wrapper">
      <div className="tree-density">
        <div className="tree-density__close-button-wrapper">
          <CustomBtn
            handleClick={() => closeHandler()}
            customClass="tree-density__close-button"
            iconClass="icon-close"
          />
        </div>
        <h3 className="tree-density__title">{translate.formatMessage({ id: 'carbon.treeDensityPopup.homogeneousAndHeterogeneous' })}</h3>
        <div className="tree-density__description">
          <div className="tree-density__description-item">
            <HomogeneousImage />
            <p className="tree-density__description-text">{translate.formatMessage({ id: 'carbon.treeDensityPopup.mixedAndHomogeneous' })}</p>
          </div>
          <div className="tree-density__description-item tree-density__legend-wrapper">
            <HeterogeneousImage />
            <span className="tree-density__legend legend-high-density">{translate.formatMessage({ id: 'carbon.treeDensityPopup.highTreeDensity' })}</span>
            <span className="tree-density__legend legend-low-density">{translate.formatMessage({ id: 'carbon.treeDensityPopup.lowTreeDensity' })}</span>
            <p className="tree-density__description-text">{translate.formatMessage({ id: 'carbon.treeDensityPopup.mixedAndHeterogeneous' })}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TreeDensityPopup;
